export function addCurrent(feedbackarticle) {
    return {
        type: 'ADD_CURRENT',
        feedbackarticle,
    }
}
